import React, { useState, useEffect, useRef } from "react";
import './VelikiDobitakNotifikacija.less';
import { NavLink } from "react-router-dom";
import { Redirect } from 'react-router'
import RiveComponent from "../Shared/RiveComponent";


export default function VelikiDobitakNotifikacija(props) {
    const [image, setImage] = React.useState(null);
    const [show, setShow] = React.useState(false);
    const [redirectToGame, setRedirectToGame] = useState(false);
    const [redirectToWinners, setRedirectToWinners] = useState(false);
    const [disableClose, setDisableClose] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
        if (props.igra != null) {
            setShow(true);
            let imgsrc = casino.config.gameImagesUrl + props.brands[props.igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(props.igra.n);
            let webP = casino.config.canIUseWebP ? '.webp' : '.jpeg';
            setImage(imgsrc + webP);

            if (props.tipNotifikacije == 9) {
                setDisableClose(true);
                setTimeout(() => setDisableClose(false), 3000);;
            }
        }
    }, [props]);

    useEffect(() => {
        if (image) {
            setTimeout(() => {
                audioRef.current?.play(); 
            }, 300);
        }
    }, [image]);

    const close = () => {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setShow(false);
        setImage(null);
        props.onClose();        
    }

    if (redirectToGame) {
        return <Redirect to={((props.routePrefix || '') + '/').replace('//', '/') + 'game/' + props.brands[props.igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(props.igra.n)} push={false} />
    }

    if (redirectToWinners) {
        return <Redirect to="/winners" push={false} />
    }

    if (show) {
        return (
            <>
                <div className="vd-overlay" onClick={!disableClose && close} />
                <div className="veliki-dobitak-notifikacija">
                    <div className="vd-gift-1"></div>
                    <div className="vd-gift-2"></div>
                    {!disableClose && <div className="vd-close-notification" onClick={close}></div>}
                    <RiveComponent
                        className="vd-rive"
                        lazyLoad={true}
                        cacheBust={`c=${casino.config.guiCacheVerzija}`} 
                        src="content/images/notifications/veliki-dobitak-modalni_v1.riv"
                        width="800"
                        height="1096"
                        useOffscreenRenderer={true}
                        playRequest={true}
                        disablePlayOutsideViewport={true}
                    />
                    <audio ref={audioRef}>
                        <source src="content/images/notifications/notoficationSound.mp3" type="audio/mpeg" />
                    </audio>

                    {image && <>
                        {props.vrstaDobitka == 1 && <h1 className="vd-title">Osvojen je veliki dobitak!</h1>}
                        {props.vrstaDobitka == 0 && <h1 className="vd-title">Osvojen je Jackpot!</h1>}
                        <div className="vd-game-img-background" onClick={() => { close(); setRedirectToGame(true) }}>
                            <span className="image-hover-icon"></span>
                            <div className="vd-game-img" style={{ backgroundImage: "url(" + image + ")" }}></div>
                        </div>
                        <div className="vd-user-info">{props.notifikacija.igrac} u igri <span onClick={() => { close(); setRedirectToGame(true) }}>{props.notifikacija.igra}</span></div>
                        {props.vrstaDobitka == 0 && <div className="vd-win-text">osvaja JACKPOT u iznosu:</div>}
                        {props.vrstaDobitka == 1 && <div className="vd-win-text">osvaja dobitak u iznosu:</div>}
                        <div className="vd-dobitak">
                            <div className="vd-iznos"> {`${casino.utils.numberToString(props.notifikacija.iznosDobitka)} €`}</div>
                        </div>
                        <h1 className="vd-congrats">Čestitamo!</h1>
                        <div className="vd-action-buttons">
                            <span className="vd-button vd-close-btn" onClick={close}>Zatvori</span>
                            <a href="dobitnici" className="vd-button vd-winners-btn" onClick={(e) => { e.preventDefault(); close(); setRedirectToWinners(true) }} >Dobitnici</a>
                        </div>
                    </>}
                </div>
            </>
        );
    } else {
            return null;
    }
}